const responsibleLogos = [
  { alt: 'Gambling Therapy', src: '/responsible/gambling-therapy.png' },
  { alt: 'Gamble Aware', src: '/responsible/gamble-aware.png' },
  { alt: 'Gordon Moody', src: '/responsible/gordon-moody.png' },
  { alt: 'Gaming Addicts Anonymous', src: '/responsible/gaming-addicts-anonymous.png' },
  { alt: '18+ only', src: '/responsible/18-plus-only.png' },
];

export default function Footer() {
  return (
    <footer className="relative bg-white border-t border-blue-200/30 pt-10 md:pt-12 pb-24 md:pb-16 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-blue-400/5 blur-[100px] rounded-full"></div>
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-6 md:mb-8">
          <img
            alt="iPAY9 logo"
            className="h-7 md:h-8 w-auto"
            src="https://storage.readdy-site.link/project_files/4032d0ab-e29f-4bfa-a716-c411b87ebbce/8f4b55af-cb32-4845-bee7-78f5728b34da_fddf9c818e4964a58fcae.png"
          />
        </div>
        <p className="text-slate-400 text-xs leading-relaxed mb-6 max-w-3xl">
          iPAY9 Online Casino Australia is built for Australian players with AUD deposits, fast withdrawals, and secure access. Minimum deposit from AUD10 and withdrawals from AUD50. Licensed under PAGCOR / Curacao.
        </p>
        <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-8 md:mb-10 pb-8 md:pb-10 border-b border-blue-200/20">
          {responsibleLogos.map((logo) => (
            <div key={logo.alt} className="h-8 md:h-10 flex items-center opacity-50 hover:opacity-100 transition-opacity">
              <img alt={logo.alt} className="h-5 md:h-7 w-auto object-contain" src={logo.src} />
            </div>
          ))}
        </div>
        <div className="text-slate-400 text-xs md:text-sm text-center">© iPAY9, 2026. iPAY9 Online Casino Australia.</div>
      </div>
    </footer>
  );
}
